import React,{useState} from 'react'
import './Navbar.css'
import logo1 from '../../img/Image-1.png'
import logo2 from '../../img/Image.png'
import { AiOutlineMenu,AiOutlineClose} from "react-icons/ai";

import USflag from '../../img/icons/us-flag.png'
const Navbar = () => {
    // countries.includes('US') === true
    const [isActive, setIsActive] = useState(false)
    const lists=['Home','About','Features','Blog','Pricing','Contact']
    const language =[
        {
            language:'English'
        },
        {
            language:'Hindi'
        },
        {
            language:'Chinease'
        },
        {
            language:'Nepali',
            icon:USflag
        }
    ]

    const activateLink=(i)=>{
        document.querySelectorAll('.nav-links ul li')[i].classList.toggle('active')
        // document.querySelectorAll('.nav-links ul li').classList.remove('active')

    }


    const mobileMenu=()=>{
        document.querySelector('.nav-links ul').classList.toggle('ham-menu')
        setIsActive(!isActive)
    }
    
    
    const closeMenu=()=>{
        document.querySelector('.nav-links ul').classList.remove('ham-menu')
        setIsActive(!isActive)

    }
  return (
    <div className="navbar">
        <div className="nav-left">
            <div className="logo-container">
                <img src={logo1} alt="" />
                <img src={logo2} alt="" />
            </div>
        </div>

        <div className="nav-right">
            <div className="nav-links">
                <ul>
                    {lists.map((item,index)=>{
                        return <li key={index} onClick={closeMenu} >{item}</li>
                    })}
                </ul>
                <div className="mobile-menu " onClick={mobileMenu}>
                    {isActive ?  <AiOutlineClose/> : <AiOutlineMenu/>}
                    
                    
                </div>
            </div>

            <div className="right-side">

            <div className="btns">
                <select name="" id="" className='select-language'>
                    {language.map((item,index)=>{
                        return <option key={index} value={item.language}>{item.language}</option>
                    })}
                </select>
                <button className='btn-download'>Download</button>
                   
                   </div>
                   
            </div>
        </div>
    </div>
  )
}

export default Navbar